var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import FelaComponent from "./fela-component";
var gridItemRule = function (_a) {
    var calcWidth = _a.calcWidth, gutter = _a.gutter;
    return ({
        width: calcWidth - (calcWidth === 100 ? 0 : gutter) + "%",
        ifSmallDown: { width: "100%" },
        position: "relative"
    });
};
var GridItem = function (_a) {
    var children = _a.children, className = _a.className, render = _a.render, _b = _a.gridSize, gridSize = _b === void 0 ? 12 : _b, _c = _a.size, size = _c === void 0 ? 1 : _c, _d = _a.gutter, gutter = _d === void 0 ? 0 : _d;
    var calcWidth = (100 / gridSize) * size;
    return (React.createElement(FelaComponent, { rule: gridItemRule, calcWidth: calcWidth, gutter: gutter, className: className, render: render }, children));
};
var rule = function (_a) {
    var verticalGutter = _a.verticalGutter;
    return ({
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        "> *": {
            marginBottom: verticalGutter
        },
        "> *:not(:last-child)": {
            ifSmallDown: { marginBottom: "2em" }
        }
    });
};
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.render = function () {
        var _a = this.props, children = _a.children, size = _a.size, _b = _a.gutter, gutter = _b === void 0 ? 0 : _b, _c = _a.verticalGutter, verticalGutter = _c === void 0 ? 0 : _c, className = _a.className, rest = __rest(_a, ["children", "size", "gutter", "verticalGutter", "className"]);
        var arr = React.Children.toArray(children);
        return (React.createElement(FelaComponent, { rule: rule, className: className, verticalGutter: verticalGutter, render: function (_a) {
                var className = _a.className;
                return (React.createElement("div", __assign({}, rest, { className: className }), arr.map(function (child) {
                    return React.cloneElement(child, {
                        gridSize: size || arr.length,
                        gutter: gutter
                    });
                })));
            } }));
    };
    Grid.Item = GridItem;
    return Grid;
}(React.Component));
export default Grid;
//# sourceMappingURL=flex-grid.js.map